import { createFileRoute, Outlet, redirect, useMatchRoute } from '@tanstack/react-router';

import { ensureSession } from '@/features/auth/api';
import { AuthShell, type AuthTab } from '@/screens/auth/AuthShell';

/** Pathless layout for the public auth screens. A verified, signed-in user is sent to the app. */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async () => {
    const s = await ensureSession();
    if (s.user?.email_verified) throw redirect({ to: '/overview' });
  },
  component: AuthFrame,
});

/**
 * Sign-in and sign-up sit in the legacy auth frame with the Sign In / Sign Up switch; forgot
 * and reset password in the same frame without it. Verify email is its own full page.
 */
function AuthFrame() {
  const matchRoute = useMatchRoute();
  if (matchRoute({ to: '/verify-email' })) return <Outlet />;
  const activeTab: AuthTab | undefined = matchRoute({ to: '/sign-in' })
    ? 'sign-in'
    : matchRoute({ to: '/sign-up' })
      ? 'sign-up'
      : undefined;
  return (
    <AuthShell activeTab={activeTab}>
      <Outlet />
    </AuthShell>
  );
}
